"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_redux_1 = require("react-redux");
var sanitizeState_1 = __importDefault(require("../helpers/sanitizeState"));
var DownloadDebugButton_1 = __importDefault(require("../components/DownloadDebugButton"));
var mapStateToProps = function (state) { return ({
    stateReport: (0, sanitizeState_1["default"])(state)
}); };
exports["default"] = (0, react_redux_1.connect)(mapStateToProps)(DownloadDebugButton_1["default"]);
